import React from 'react';


const AuthSliderOvalIcon = ({width = 43, height = 10, color = "#4FADA9", ...props}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 43 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={42.5} height={10} rx={5} fill={color}/>
    </svg>
);


export default AuthSliderOvalIcon;